import i18n from "../i18n/config";
import { translateBackendError } from "./errorTranslator";

// Permission mapping for user-friendly error messages (EN — fallback for i18n defaultValue)
export const permissionMessages = {
  // Files
  can_files_create: "You don't have permission to create files",
  can_files_update: "You don't have permission to update files",
  can_files_view: "You don't have permission to view files",
  can_files_delete: "You don't have permission to delete files",

  // Forms
  can_forms_create: "You don't have permission to create forms",
  can_forms_update: "You don't have permission to update forms",
  can_forms_view: "You don't have permission to view forms",
  can_forms_delete: "You don't have permission to delete forms",

  // Patients
  can_patients_create: "You don't have permission to create patients",
  can_patients_update: "You don't have permission to update patients",
  can_patients_view: "You don't have permission to view patients",
  can_patients_delete: "You don't have permission to delete patients",

  // Doctors
  can_doctors_create: "You don't have permission to create doctors",
  can_doctors_update: "You don't have permission to update doctors",
  can_doctors_view: "You don't have permission to view doctors",
  can_doctors_delete: "You don't have permission to delete doctors",

  // Form Answers
  can_form_answers_create: "You don't have permission to create form answers",
  can_form_answers_update: "You don't have permission to update form answers",
  can_form_answers_view: "You don't have permission to view form answers",
  can_form_answers_delete: "You don't have permission to delete form answers",

  // Invitations
  can_invitations_create: "You don't have permission to create invitations",
  can_invitations_update: "You don't have permission to update invitations",
  can_invitations_view: "You don't have permission to view invitations",
  can_invitations_delete: "You don't have permission to delete invitations",

  // Scoring Formulas
  can_scoring_formulas_create: "You don't have permission to create scoring formulas",
  can_scoring_formulas_update: "You don't have permission to update scoring formulas",
  can_scoring_formulas_view: "You don't have permission to view scoring formulas",
  can_scoring_formulas_delete: "You don't have permission to delete scoring formulas",

  // Patient Files
  can_patient_files_upload: "You don't have permission to upload patient files",
  can_patient_files_update: "You don't have permission to update patient files",
  can_patient_files_view: "You don't have permission to view patient files",
  can_patient_files_delete: "You don't have permission to delete patient files",

  // Permission Groups
  can_permission_groups_create: "You don't have permission to create permission groups",
  can_permission_groups_update: "You don't have permission to update permission groups",
  can_permission_groups_view: "You don't have permission to view permission groups",
  can_permission_groups_delete: "You don't have permission to delete permission groups",

  // Own — doctor scope
  can_own_patients_create: "You don't have permission to create your own patients",
  can_own_patients_update: "You don't have permission to update your own patients",
  can_own_patients_view: "You don't have permission to view your own patients",
  can_own_patients_delete: "You don't have permission to delete your own patients",

  can_own_form_answers_create: "You don't have permission to create your own form answers",
  can_own_form_answers_update: "You don't have permission to update your own form answers",
  can_own_form_answers_view: "You don't have permission to view your own form answers",
  can_own_form_answers_delete: "You don't have permission to delete your own form answers",

  can_own_patient_files_upload: "You don't have permission to upload your own patient files",
  can_own_patient_files_update: "You don't have permission to update your own patient files",
  can_own_patient_files_view: "You don't have permission to view your own patient files",
  can_own_patient_files_delete: "You don't have permission to delete your own patient files",

  can_own_files_create: "You don't have permission to create your own files",
  can_own_files_update: "You don't have permission to update your own files",
  can_own_files_view: "You don't have permission to view your own files",
  can_own_files_delete: "You don't have permission to delete your own files",

  can_own_forms_create: "You don't have permission to create your own forms",
  can_own_forms_update: "You don't have permission to update your own forms",
  can_own_forms_view: "You don't have permission to view your own forms",
  can_own_forms_delete: "You don't have permission to delete your own forms",

  can_own_scoring_formulas_create: "You don't have permission to create your own scoring formulas",
  can_own_scoring_formulas_update: "You don't have permission to update your own scoring formulas",
  can_own_scoring_formulas_view: "You don't have permission to view your own scoring formulas",
  can_own_scoring_formulas_delete: "You don't have permission to delete your own scoring formulas",

  can_own_invitations_create: "You don't have permission to create your own invitations",
  can_own_invitations_update: "You don't have permission to update your own invitations",
  can_own_invitations_view: "You don't have permission to view your own invitations",
  can_own_invitations_delete: "You don't have permission to delete your own invitations",

  can_own_doctors_create: "You don't have permission to invite or create subordinate doctors",
  can_own_doctors_update: "You don't have permission to update subordinate doctors",
  can_own_doctors_view: "You don't have permission to view subordinate doctors",
  can_own_doctors_delete: "You don't have permission to remove subordinate doctors",

  can_own_permission_groups_create: "You don't have permission to create permission groups",
  can_own_permission_groups_add: "You don't have permission to assign permission groups",
  can_own_permission_groups_remove: "You don't have permission to remove permission groups",
  can_own_permission_groups_view: "You don't have permission to view permission groups",
  can_own_permission_groups_update: "You don't have permission to update permission groups",
};

/** Türkçe kullanıcı mesajları (doktor paneli — backend `checkPermission` ile uyumlu) */
export const permissionMessagesTr = {
  can_files_create: "Dosya oluşturma yetkiniz yok.",
  can_files_update: "Dosya güncelleme yetkiniz yok.",
  can_files_view: "Dosya görüntüleme yetkiniz yok.",
  can_files_delete: "Dosya silme yetkiniz yok.",

  can_forms_create: "Form oluşturma yetkiniz yok.",
  can_forms_update: "Form güncelleme yetkiniz yok.",
  can_forms_view: "Form görüntüleme yetkiniz yok.",
  can_forms_delete: "Form silme yetkiniz yok.",

  can_patients_create: "Hasta oluşturma yetkiniz yok.",
  can_patients_update: "Hasta güncelleme yetkiniz yok.",
  can_patients_view: "Hasta görüntüleme yetkiniz yok.",
  can_patients_delete: "Hasta silme yetkiniz yok.",

  can_doctors_create: "Doktor oluşturma / davet etme yetkiniz yok.",
  can_doctors_update: "Doktor güncelleme yetkiniz yok.",
  can_doctors_view: "Doktor görüntüleme yetkiniz yok.",
  can_doctors_delete: "Doktor silme yetkiniz yok.",

  can_form_answers_create: "Form cevabı oluşturma yetkiniz yok.",
  can_form_answers_update: "Form cevabı güncelleme yetkiniz yok.",
  can_form_answers_view: "Form cevabı görüntüleme yetkiniz yok.",
  can_form_answers_delete: "Form cevabı silme yetkiniz yok.",

  can_invitations_create: "Davet oluşturma yetkiniz yok.",
  can_invitations_update: "Davet güncelleme yetkiniz yok.",
  can_invitations_view: "Davet görüntüleme yetkiniz yok.",
  can_invitations_delete: "Davet silme yetkiniz yok.",

  can_scoring_formulas_create: "Skor formülü oluşturma yetkiniz yok.",
  can_scoring_formulas_update: "Skor formülü güncelleme yetkiniz yok.",
  can_scoring_formulas_view: "Skor formülü görüntüleme yetkiniz yok.",
  can_scoring_formulas_delete: "Skor formülü silme yetkiniz yok.",

  can_patient_files_upload: "Hasta dosyası yükleme yetkiniz yok.",
  can_patient_files_update: "Hasta dosyası güncelleme yetkiniz yok.",
  can_patient_files_view: "Hasta dosyası görüntüleme yetkiniz yok.",
  can_patient_files_delete: "Hasta dosyası silme yetkiniz yok.",

  can_permission_groups_create: "Yetki grubu oluşturma yetkiniz yok.",
  can_permission_groups_update: "Yetki grubu güncelleme yetkiniz yok.",
  can_permission_groups_view: "Yetki grubu görüntüleme yetkiniz yok.",
  can_permission_groups_delete: "Yetki grubu silme yetkiniz yok.",

  can_own_patients_create: "Kendi hastalarınız için oluşturma yetkiniz yok.",
  can_own_patients_update: "Kendi hastalarınızı güncelleme yetkiniz yok.",
  can_own_patients_view: "Kendi hastalarınızı görüntüleme yetkiniz yok.",
  can_own_patients_delete: "Kendi hastalarınızı silme yetkiniz yok.",

  can_own_form_answers_create: "Form cevabı oluşturma yetkiniz yok.",
  can_own_form_answers_update: "Form cevabı güncelleme yetkiniz yok.",
  can_own_form_answers_view: "Form cevabı görüntüleme yetkiniz yok.",
  can_own_form_answers_delete: "Form cevabı silme yetkiniz yok.",

  can_own_patient_files_upload: "Hasta dosyası yükleme yetkiniz yok.",
  can_own_patient_files_update: "Hasta dosyası güncelleme yetkiniz yok.",
  can_own_patient_files_view: "Hasta dosyası görüntüleme yetkiniz yok.",
  can_own_patient_files_delete: "Hasta dosyası silme yetkiniz yok.",

  can_own_files_create: "Dosya oluşturma yetkiniz yok.",
  can_own_files_update: "Dosya güncelleme yetkiniz yok.",
  can_own_files_view: "Dosya görüntüleme yetkiniz yok.",
  can_own_files_delete: "Dosya silme yetkiniz yok.",

  can_own_forms_create: "Form oluşturma yetkiniz yok.",
  can_own_forms_update: "Form güncelleme yetkiniz yok.",
  can_own_forms_view: "Form görüntüleme yetkiniz yok.",
  can_own_forms_delete: "Form silme yetkiniz yok.",

  can_own_scoring_formulas_create: "Skor formülü oluşturma yetkiniz yok.",
  can_own_scoring_formulas_update: "Skor formülü güncelleme yetkiniz yok.",
  can_own_scoring_formulas_view: "Skor formülü görüntüleme yetkiniz yok.",
  can_own_scoring_formulas_delete: "Skor formülü silme yetkiniz yok.",

  can_own_invitations_create: "Davet oluşturma yetkiniz yok.",
  can_own_invitations_update: "Davet güncelleme yetkiniz yok.",
  can_own_invitations_view: "Davet görüntüleme yetkiniz yok.",
  can_own_invitations_delete: "Davet silme yetkiniz yok.",

  can_own_doctors_create: "Alt doktor ekleme / davet etme yetkiniz yok.",
  can_own_doctors_update: "Alt doktor güncelleme yetkiniz yok.",
  can_own_doctors_view: "Alt doktor görüntüleme yetkiniz yok.",
  can_own_doctors_delete: "Alt doktor silme yetkiniz yok.",

  can_own_permission_groups_create: "Yetki grubu oluşturma yetkiniz yok.",
  can_own_permission_groups_add: "Yetki grubu atama yetkiniz yok.",
  can_own_permission_groups_remove: "Yetki grubu kaldırma yetkiniz yok.",
  can_own_permission_groups_view: "Yetki grubu görüntüleme yetkiniz yok.",
  can_own_permission_groups_update: "Yetki grubu güncelleme yetkiniz yok.",
};

const GENERIC_FALLBACK_TR = "Bu işlem için yetkiniz yok.";

const API_ERRORS_NS = "apiErrors";

/** tr / en / fr — i18n.language bazen en-US gibi gelebilir */
function normalizeLng(lng) {
  if (!lng) return "en";
  const base = String(lng).split("-")[0].toLowerCase();
  return ["tr", "en", "fr"].includes(base) ? base : "en";
}

/** UI dili: yalnızca i18n (localStorage kullanılmaz). */
function currentLng() {
  return normalizeLng(i18n.resolvedLanguage || i18n.language || "en");
}

function getApiErrorsBundle(lng) {
  try {
    return i18n.getResourceBundle(normalizeLng(lng), API_ERRORS_NS);
  } catch {
    return undefined;
  }
}

function translateErrorCode(code) {
  const lng = currentLng();
  const cur = getApiErrorsBundle(lng)?.errorCodes?.[code];
  if (typeof cur === "string" && cur.length > 0) return cur;
  const en = getApiErrorsBundle("en")?.errorCodes?.[code];
  if (typeof en === "string" && en.length > 0) return en;
  return code;
}

function translatePhrase(phraseId) {
  const lng = currentLng();
  const cur = getApiErrorsBundle(lng)?.phrases?.[phraseId];
  if (typeof cur === "string" && cur.length > 0) return cur;
  const en = getApiErrorsBundle("en")?.phrases?.[phraseId];
  if (typeof en === "string" && en.length > 0) return en;
  const tr = getApiErrorsBundle("tr")?.phrases?.[phraseId];
  if (typeof tr === "string" && tr.length > 0) return tr;
  return phraseId;
}

function translatePermissionKey(permission) {
  const lng = currentLng();
  const cur = getApiErrorsBundle(lng)?.permissions?.[permission];
  if (typeof cur === "string" && cur.length > 0) return cur;
  const en = getApiErrorsBundle("en")?.permissions?.[permission];
  if (typeof en === "string" && en.length > 0) return en;
  const tr = getApiErrorsBundle("tr")?.permissions?.[permission];
  if (typeof tr === "string" && tr.length > 0) return tr;
  return (
    permissionMessagesTr[permission] ||
    permissionMessages[permission] ||
    permission
  );
}

function translateGenericDenied() {
  const lng = currentLng();
  const cur = getApiErrorsBundle(lng)?.genericPermissionDenied;
  if (typeof cur === "string" && cur.length > 0) return cur;
  const en = getApiErrorsBundle("en")?.genericPermissionDenied;
  if (typeof en === "string" && en.length > 0) return en;
  return GENERIC_FALLBACK_TR;
}

/**
 * Backend'den gelen sabit metin → apiErrors.phrases.* anahtarı (Türkçe gövde ile eşleşme).
 * Nokta / tırnak varyasyonları için ayrıca lookupPhrase kullanılır.
 */
const BACKEND_TR_TO_PHRASE = {
  "Form görüntüleme yetkiniz yok": "formViewNoPermission",
  "Bu formu görüntüleme yetkiniz yok": "thisFormViewNoPermission",
  "Form oluşturma yetkiniz yok": "formCreateNoPermission",
  "Bu file'a form ekleme yetkiniz yok": "addFormToFileNoPermission",
  "Form güncelleme yetkiniz yok": "formUpdateNoPermission",
  "Bu formu güncelleme yetkiniz yok": "thisFormUpdateNoPermission",
  "Form silme yetkiniz yok": "formDeleteNoPermission",
  "Form bulunamadı veya güncelleme yetkiniz yok": "formNotFoundOrUpdateDenied",
  "Form bulunamadı veya silme yetkiniz yok": "formNotFoundOrDeleteDenied",
  "Bu formu silme yetkiniz yok": "thisFormDeleteNoPermission",
  "Bu formu doldurma yetkiniz yok": "fillFormNoPermission",
  "Bu form için davet gönderme yetkiniz yok": "sendInviteNoPermission",
  "Bu daveti iptal etme yetkiniz yok": "revokeInviteNoPermission",
  "Bu hasta için davet görüntüleme yetkiniz yok": "viewPatientInviteNoPermission",
  "Bu kuruma erişim yetkiniz yok.": "tenantAccessDenied",
  "Bu kuruma erişim yetkiniz yok": "tenantAccessDenied",
  "Doktor görüntüleme yetkiniz yok.": "doctorViewDenied",
  "Doktor görüntüleme yetkiniz yok": "doctorViewDenied",
  "Bu doktor bilgilerine erişim yetkiniz yok.": "doctorAccessDenied",
  "Bu doktor bilgilerine erişim yetkiniz yok": "doctorAccessDenied",
  "Bu doktoru güncelleme yetkiniz yok.": "doctorUpdateDenied",
  "Bu doktoru güncelleme yetkiniz yok": "doctorUpdateDenied",
  "Bu doktoru silme yetkiniz yok. Sadece kendi oluşturduğunuz doktorları silebilirsiniz.":
    "doctorDeleteDenied",
  "Doktor silme yetkiniz yok.": "doctorDeleteNotAllowed",
  "Doktor silme yetkiniz yok": "doctorDeleteNotAllowed",
  "Doktor bulunamadı veya bu doktora erişim yetkiniz yok.": "doctorNotFoundOrAccessDenied",
  "Doktor bulunamadı veya bu doktora erişim yetkiniz yok": "doctorNotFoundOrAccessDenied",
  "Alt doktor ekleme yetkiniz yok.": "subDoctorAddDenied",
  "Alt doktor ekleme yetkiniz yok": "subDoctorAddDenied",
  "Doktor ekleme yetkiniz yok.": "doctorAddDenied",
  "Doktor ekleme yetkiniz yok": "doctorAddDenied",
  "Alt doktorlara permission group atama yetkiniz yok.": "assignPermissionGroupDenied",
  "Alt doktorlara permission group atama yetkiniz yok": "assignPermissionGroupDenied",
  "Kendi formüllerinizi oluşturma yetkiniz yok": "createOwnFormulasDenied",
  "Bu file'a formül ekleme yetkiniz yok": "addFormulaToFileDenied",
  "Formül bulunamadı veya güncelleme yetkiniz yok": "formulaNotFoundOrUpdateDenied",
  "Formül bulunamadı veya silme yetkiniz yok": "formulaNotFoundOrDeleteDenied",
  "Bu dosyaya erişim yetkiniz yok": "fileAccessDenied",
  "Kendi file'larınızı oluşturma yetkiniz yok": "createOwnFilesDenied",
  "Bu dosyayı güncelleme yetkiniz yok": "fileUpdateDenied",
  "Bu dosyayı silme yetkiniz yok": "fileDeleteDenied",
  "File kopyalama yetkiniz yok. File oluşturma yetkiniz olmalı.": "fileCopyDenied",
  "Bu dosyayı paylaşma yetkiniz yok.": "shareFileDenied",
  "Bu dosyayı paylaşma yetkiniz yok": "shareFileDenied",
  "Bu işlem için yetkiniz yok": "roleOperationDenied",
  "Bu işlem için yetkiniz yok.": "roleOperationDenied",
  "Bu hastaya erişim yetkiniz yok!": "patientAccessDenied",
};

/** Backend `error` string → apiErrors.errorCodes (403 hasta vb.) */
const BACKEND_ERROR_STRING_TO_CODE = {
  noPermissionToDeletePatient: "NO_PERMISSION_TO_DELETE_PATIENT",
};

function lookupPhraseId(raw) {
  if (!raw) return null;
  const trimmed = raw.trim();
  const direct = BACKEND_TR_TO_PHRASE[trimmed];
  if (direct) return direct;
  const noDot = trimmed.replace(/\.$/, "");
  return BACKEND_TR_TO_PHRASE[noDot] || null;
}

/**
 * Backend yanıtı: `{ errorCode, requiredPermission? }` veya eski düz metin `message`.
 * Çeviri: `apiErrors.errorCodes.*` ve `apiErrors.permissions.*` — dil yalnızca i18n üzerinden.
 */
export function parsePermissionError(input) {
  if (input == null || input === "") {
    return translateGenericDenied();
  }

  if (typeof input === "object" && !Array.isArray(input)) {
    const data = input;
    if (data.code === "SUBSCRIPTION_REQUIRED") {
      const msg = [data.message, data.error].find(
        (s) => typeof s === "string" && s.trim().length > 0
      );
      if (msg) return msg.trim();
    }
    if (
      data.errorCode === "PERMISSION_DENIED" &&
      typeof data.requiredPermission === "string" &&
      data.requiredPermission.length > 0
    ) {
      return translatePermissionKey(data.requiredPermission);
    }
    if (typeof data.errorCode === "string" && data.errorCode.length > 0) {
      return translateErrorCode(data.errorCode);
    }
    // Eski yanıtlar: yalnızca `error` anahtarı (apiErrors.errorCodes öncelikli)
    if (typeof data.error === "string" && data.error.trim().length > 0) {
      const errStr = data.error.trim();
      const mapped = BACKEND_ERROR_STRING_TO_CODE[errStr];
      if (mapped) return translateErrorCode(mapped);
      const fromErrorsNs = translateBackendError({ error: errStr });
      if (fromErrorsNs && fromErrorsNs !== errStr) {
        return fromErrorsNs;
      }
    }
    const legacy = String(data.message || data.error || "").trim();
    if (legacy) return parseLegacyPermissionString(legacy);
    return translateGenericDenied();
  }

  const raw = typeof input === "string" ? input.trim() : String(input);
  return parseLegacyPermissionString(raw);
}

function parseLegacyPermissionString(raw) {
  if (!raw) return translateGenericDenied();

  const mappedCode = BACKEND_ERROR_STRING_TO_CODE[raw.trim()];
  if (mappedCode) return translateErrorCode(mappedCode);

  const phraseId = lookupPhraseId(raw);
  if (phraseId) {
    return translatePhrase(phraseId);
  }

  const permissionMatch = raw.match(/can_[a-z0-9_]+/);
  if (permissionMatch) {
    return translatePermissionKey(permissionMatch[0]);
  }

  if (raw.length > 0) {
    return raw;
  }

  return translateGenericDenied();
}
